import React from 'react'
import TagsInput from 'react-tagsinput'
import { Input } from 'semantic-ui-react'

class Tags extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      tags: (props.tags && props.tags.length > 0) ? props.tags : [], 
      tag: '',
    }
  }

  handleChange(tags) {
    this.setState({ tags }, () => {
      this.props.onChangeTags(this.state);
    });    
  }

  handleChangeInput(tag) {
    this.setState({ tag })
  }

  render() {
    function defaultRenderInput({ addTag, ...props }) {
      let { onChange, value, ...other } = props
      return (
        <Input
          type="text"
          onChange={onChange}          
          style={{ width: '100%', padding: "10px 0" }}
          value={value} {...other}
        />
      )
    }
    function defaultRenderLayout(tagComponents, inputComponent) {
      return (
        <div>
          <div style={{ width: '100%', display: 'block' }}>
            {inputComponent}
          </div>
          <div style={{ width: '300px', position: 'absolute', left: '20px' }}>
            {tagComponents}
          </div>
        </div>
      )
    }
    return (
      <TagsInput
        value={this.state.tags}
        renderInput={defaultRenderInput}
        renderLayout={defaultRenderLayout}
        onChange={this.handleChange.bind(this)}
        inputValue={this.state.tag}
        onChangeInput={this.handleChangeInput.bind(this)}
      />
    )
  }
}

export default Tags